module.exports = __webpack_public_path__ + "img/covid-protection-shield.36732961.svg";